import { DesignSystemContent } from '@/pages/dev-tools'
import { UiCustomModal } from '@/shared/ui'
import { useState } from 'react'
import styles from './styles.module.scss'

/**
 * Nút mở tra cứu design system trong Modal full màn hình. CHỈ hiện khi chạy dev.
 *
 * Cho phép dev tra cứu token, components, templates và rules trực tiếp
 * mà không phải chuyển trang hay mất context làm việc hiện tại.
 */
export default function DesignSystemLauncher() {
  const [open, setOpen] = useState(false)

  if (!import.meta.env.DEV) return null

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        title="Mở tra cứu Design System (chỉ có ở môi trường dev)"
        className={styles.launcherBtn}
      >
        🎨
      </button>

      <UiCustomModal
        title="VBDT Design System Explorer"
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        size="full"
        style={{ top: 0, paddingBottom: 0, maxWidth: '100vw' }}
        wrapClassName={styles.fullscreenModalWrap}
        styles={{
          body: {
            height: 'calc(100vh - 110px)',
            overflowY: 'auto',
            paddingRight: 'var(--vbdt-space-sm)',
          },
        }}
        destroyOnHidden
      >
        <DesignSystemContent />
      </UiCustomModal>
    </>
  )
}
